import { z } from 'zod';

export const DepthOfFieldSchema = z.object({
  enabled: z.boolean(), method: z.enum(['depth', 'band']), blur: z.number().min(0).max(28),
  width: z.number().min(.04).max(.65), fadeTopDown: z.boolean(), focus: z.enum(['rider', 'center']),
}).strict();
export const DepthOfFieldPreviewSchema = z.object({ original: z.boolean(), mask: z.boolean() }).strict();

export function readDepthOfField(value: string | null): z.infer<typeof DepthOfFieldSchema> | undefined {
  if (!value) return undefined;
  try {
    const result = DepthOfFieldSchema.safeParse(JSON.parse(value));
    return result.success ? result.data : undefined;
  } catch { return undefined; }
}
